"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var react_spring_1 = require("react-spring");
var react_focus_lock_1 = __importDefault(require("react-focus-lock"));
var react_remove_scroll_1 = require("react-remove-scroll");
var ThemeProvider_1 = require("@seaweb/coral/components/ThemeProvider");
var color_1 = require("@seaweb/coral/utils/color");
var useWrapEvent_1 = __importDefault(require("@seaweb/coral/hooks/useWrapEvent"));
var DialogContext_1 = require("./DialogContext");
var DialogBoxContainer = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  width: 480px;\n  box-shadow: 0 4px 32px ", ";\n\n  ", "\n\n  &:focus {\n    outline: none;\n  }\n"], ["\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  width: 480px;\n  box-shadow: 0 4px 32px ", ";\n\n  ",
    "\n\n  &:focus {\n    outline: none;\n  }\n"])), color_1.alp(ThemeProvider_1.palette.black, 0.1), function (_a) {
    var _b = _a.theme, spacing = _b.spacing, colors = _b.colors, typography = _b.typography;
    return styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-radius: ", "px;\n    border: solid 1px ", ";\n    font-family: ", ";\n    font-size: ", "px;\n    background-color: ", ";\n  "], ["\n    border-radius: ", "px;\n    border: solid 1px ", ";\n    font-family: ", ";\n    font-size: ", "px;\n    background-color: ", ";\n  "])), spacing.radius, colors.border, typography.main, typography.sizes.main, colors.plain);
});
var AnimatedDialogBoxContainer = react_spring_1.animated(DialogBoxContainer);
var DialogBox = react_1.forwardRef(function Dialog(_a, ref) {
    var as = _a.as, _b = _a.role, role = _b === void 0 ? 'dialog' : _b, _c = _a.tabIndex, tabIndex = _c === void 0 ? 0 : _c, styleProp = _a.style, onKeyDown = _a.onKeyDown, _d = _a.disableFocusLock, disableFocusLock = _d === void 0 ? false : _d, _e = _a.disableScrollLock, disableScrollLock = _e === void 0 ? false : _e, props = __rest(_a, ["as", "role", "tabIndex", "style", "onKeyDown", "disableFocusLock", "disableScrollLock"]);
    var _f = DialogContext_1.useDialogContext(), isOpen = _f.isOpen, setIsOpen = _f.setIsOpen, id = _f.id, springStyle = _f.springStyle;
    var handleKeyDown = useWrapEvent_1.default(onKeyDown, function (e) {
        if (e.key === 'Escape') {
            setIsOpen(false);
        }
    });
    return (react_1.default.createElement(react_focus_lock_1.default, { disabled: !isOpen || disableFocusLock },
        react_1.default.createElement(react_remove_scroll_1.RemoveScroll, { enabled: isOpen && !disableScrollLock },
            react_1.default.createElement(AnimatedDialogBoxContainer, __assign({ as: as, ref: ref, role: role, tabIndex: isOpen ? tabIndex : null, "aria-modal": true, "aria-labelledby": "dialog:" + id + "-title", style: __assign({ transform: springStyle.transform }, styleProp), onKeyDown: handleKeyDown, "data-coral-dialog-box": "" }, props)))));
});
exports.default = react_1.memo(DialogBox);
var templateObject_1, templateObject_2;
